import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title } from 'src/app/shared/models/title.model';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Image } from 'src/app/shared/models/image.model';
import { TitlesService } from '../titles.service';
import { ImageResponse } from 'src/app/shared/models/image-response.model';
import { NgxGalleryOptions, NgxGalleryImage } from 'ngx-gallery';
import 'hammerjs'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ImageUploadComponent } from '../../images/image-upload/image-upload.component';
import { Purpose } from 'src/app/shared/models/purpose.model';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-title-detail',
  templateUrl: './title-detail.component.html',
  styleUrls: ['./title-detail.component.scss']
})
export class TitleDetailComponent implements OnInit {

  title: Title;
  images: Image[];
  stock: string;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  modalOptions: NgbModalOptions;
  purposes: Purpose[];
  
  private routeParamSubscription: Subscription = null;
  private imagesSubscription: Subscription = null;
  private notAssignedPurposes: Subscription = null;
  private deleteImageSubscription: Subscription = null;

  constructor(private route: ActivatedRoute,
              private titlesService: TitlesService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              private toastr: ToastrService) { 

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };
  }

  ngOnInit() {
    this.galleryImages = [];
    this.galleryOptions = [
      {
        width: '100%',
        height: '400px',
        imageAutoPlay: true,
        imageAutoPlayInterval: 10000,
        imageDescription: true,
        imageInfinityMove: true,
        thumbnails: false,
        thumbnailsColumns: 4,
        thumbnailsRemainingCount: true,
        previewBullets: true,
        previewFullscreen: true,
        previewKeyboardNavigation: true,
        previewCloseOnEsc: true,
        previewZoom: true,
        previewDescription: true,
        previewInfinityMove: true
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false
      }
    ];

    this.routeParamSubscription = this.route
            .params
            .subscribe(params => {
                this.title = JSON.parse(params['title']);
                console.log( this.title);
                this.stock = JSON.parse(params['stock']);

                this.getImages();
                this.getNotAssignedPurposes();
            });
  }

  /**
   * OnDestroy
   */
  ngOnDestroy(): void {
    if (this.routeParamSubscription  !== null) { this.routeParamSubscription.unsubscribe();  }
    if (this.imagesSubscription      !== null) { this.imagesSubscription.unsubscribe();      }    
    if (this.notAssignedPurposes     !== null) { this.notAssignedPurposes.unsubscribe();     }
    if (this.deleteImageSubscription !== null) { this.deleteImageSubscription.unsubscribe(); }
    
  }

  /**
   * 
   */
  getImages() {
    this.spinner.show();
    this.imagesSubscription = this.titlesService.getImages(this.title.title_id.toString()).subscribe((result: ImageResponse) => {
      this.galleryImages = [];
      // console.log(result.images);
      this.images = result.images;
      // Se agregan las imagenes a la galeria
      this.images.forEach(value => {
        // Si la imagen no tiene una url, no se agrega
        if (value.image_url !== '') {
          let imageGalery = {
              small: value.preview_url_small,
              medium: value.preview_url_medium,
              big: value.image_url,
              description: `${value.purpose.name} (${value.resolution.name})`
          }
          this.galleryImages.push(imageGalery)
        }
      });
      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      console.log(error.message);
    });
  }

  /**
   * 
   */
  getNotAssignedPurposes() {
    this.spinner.show();
    this.notAssignedPurposes = this.titlesService.getNotAssigmentPurposes(this.title.isbn).subscribe((result: Purpose[]) => {
      this.purposes = result;
      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      console.log(error.message);
    });
  }

  /**
   *
   */
  onAddImage(): void {
    
    const modalRef = this.modalService.open(ImageUploadComponent, this.modalOptions);
    modalRef.componentInstance.paramTitle   = this.title;
    modalRef.componentInstance.paramStockId = this.stock;
    modalRef.result.then((result) => {
      this.refresh();
    }, (reason) => { });
  }

  /**
   * 
   * @param id 
   */
  onDeleteImage(id: string): void {
    Swal.fire({
      title: '¿Seguro que desea eliminar?',
      text: '¡No podrás recuperar la imagen seleccionada!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Bórrala!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.deleteImageSubscription = this.titlesService.deleteImage(id).subscribe(r => {
          this.getImages();
          this.getNotAssignedPurposes();
          
          this.spinner.hide();
          Swal.fire('Eliminado!', 'La imagen ha sido eliminada.', 'success');
        },
        (error) => {
          this.spinner.hide();
          this.toastr.info(error);
          console.error('error to delete item', error);
        });
      }
    });
  }

  refresh() {
    window.location.replace('/'+ window.location.href);
  }
}
